export default __webpack_public_path__ + "static/media/15.6077354f.mp3";